import React from 'react';
import { Divider } from '@mui/material';
import {
  Edit as EditIcon,
  Delete as DeleteIcon,
  Visibility as ViewIcon,
  Publish as PublishIcon,
  Archive as ArchiveIcon,
  Unarchive as UnarchiveIcon
} from '@mui/icons-material';
import StyledMenu from '../../../../components/card/StyledMenu';
import MenuAction from '../../../../components/card/MenuAction';

const CardMenu = ({
  menuAnchor,
  onClose,
  onViewClick,
  onEditClick,
  onDeleteClick,
  onPublishClick,
  onArchiveClick,
  onUnarchiveClick,
  tabType = 'draft',
  // Use actions object to control which menu items appear
  actions = {
    view: true,
    edit: true,
    delete: true,
    archive: false,
    restore: false,
    publish: false
  }
}) => {
  // Handle actions with appropriate propagation stopping
  const handleAction = (actionFn) => (event) => {
    event.stopPropagation();
    actionFn(event);
    onClose();
  };

  return (
    <StyledMenu
      anchorEl={menuAnchor}
      onClose={onClose}
    >
      {/* View option - always available */}
      {actions.view && (
        <MenuAction
          icon={<ViewIcon />}
          text="View Details"
          onClick={handleAction(onViewClick)}
        />
      )}

      {/* Edit option - for draft content */}
      {actions.edit && (
        <MenuAction
          icon={<EditIcon />}
          text="Edit"
          onClick={handleAction(onEditClick)}
        />
      )}

      {/* Publish option - for draft content */}
      {actions.publish && onPublishClick && (
        <MenuAction
          icon={<PublishIcon />}
          text="Publish"
          onClick={handleAction(onPublishClick)}
        />
      )}

      {/* Archive option - for published content */}
      {actions.archive && onArchiveClick && (
        <MenuAction
          icon={<ArchiveIcon />}
          text="Archive"
          onClick={handleAction(onArchiveClick)}
        />
      )}

      {/* Restore option - for archived content */}
      {actions.restore && onUnarchiveClick && (
        <MenuAction
          icon={<UnarchiveIcon />}
          text="Restore"
          onClick={handleAction(onUnarchiveClick)}
        />
      )}

      {/* Only show divider if delete action is available */}
      {actions.delete && <Divider />}

      {/* Delete option - primarily for draft content */}
      {actions.delete && (
        <MenuAction
          icon={<DeleteIcon />}
          text="Delete"
          onClick={handleAction(onDeleteClick)}
          danger
        />
      )}
    </StyledMenu>
  );
};

export default CardMenu;